// extracted by mini-css-extract-plugin
export default {"mr12":"AdvancedSearchLink_mr12__9lGCR"};